export default {
  name: 'lx-info-message',
}
